const MenuItemTypes = Object.freeze({
  CAMPAIGNS: 'CAMPAIGNS',
  MEMBERS: 'MEMBERS',
  WINNERS: 'WINNERS',
});

export default MenuItemTypes;
